<template>
  <el-dialog :visible.sync="open" title="Edit trigger">
    <el-form label-position="left" label-width="140px">
      <el-form-item label="Trigger point">
        <el-input-number v-model="tresholdvalue" :min="1"></el-input-number>
      </el-form-item>
      <el-form-item label="Frequency">
        <el-select v-model="frequency">
          <el-option label="No frequency" value="none"></el-option>
          <el-option label="X times a day" value="day"></el-option>
          <el-option label="X times a week" value="week"></el-option>
          <el-option label="X times a month" value="month"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Timeframe">
        <el-select v-model="timeframe">
          <el-option :label="$t('common.timeframe.noperiod')" value="none"></el-option>
          <el-option :label="$t('common.timeframe.morning')" value="morning"></el-option>
          <el-option :label="$t('common.timeframe.midday')" value="midday"></el-option>
          <el-option :label="$t('common.timeframe.afternoon')" value="afternoon"></el-option>
          <el-option :label="$t('common.timeframe.evening')" value="evening"></el-option>
          <el-option :label="$t('common.timeframe.day')" value="day"></el-option>
          <el-option :label="$t('common.timeframe.night')" value="night"></el-option>
          <el-option :label="$t('common.timeframe.monday')" value="monday"></el-option>
          <el-option :label="$t('common.timeframe.tuesday')" value="tuesday"></el-option>
          <el-option :label="$t('common.timeframe.wednesday')" value="wednesday"></el-option>
          <el-option :label="$t('common.timeframe.thursday')" value="thursday"></el-option>
          <el-option :label="$t('common.timeframe.friday')" value="friday"></el-option>
          <el-option :label="$t('common.timeframe.saturday')" value="saturday"></el-option>
          <el-option :label="$t('common.timeframe.sunday')" value="sunday"></el-option>
          <el-option :label="$t('common.timeframe.weekend')" value="weekend"></el-option>
        </el-select>
      </el-form-item>
    </el-form><span class="dialog-footer" slot="footer">
      <el-button @click="close">{{ 'Cancel' }}</el-button>
      <el-button type="primary" @click="update">{{ 'Save' }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  props: ['badge', 'open'],
  data () {
    return {
      lang: 'fr',
      timeframe: '',
      frequency: '',
      tresholdvalue: ''
    }
  },
  methods: {

    close () {
      this.$emit('close')
    },
    update () {
      var triggers = {
        timeframe: this.timeframe,
        frequency: this.frequency,
        tresholdvalue: this.tresholdvalue
      }
      this.$emit('update', triggers)
    }

  },
  created () {
    this.timeframe = '' + this.badge.timeframe
    this.frequency = '' + this.badge.frequency
    this.tresholdvalue = '' + this.badge.tresholdvalue
  }
}
</script>



// WEBPACK FOOTER //
// src/components/badges/CrudTrigger.vue